import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';

const Blog = ({ onSectionChange }) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  // Global mouse tracking for the parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth) - 0.5,
        y: (e.clientY / window.innerHeight) - 0.5,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="relative overflow-x-hidden bg-[#F0F4F8] text-[#4A5568] antialiased font-sans min-h-screen">
      <Header />

      {/* --- GLOBAL DYNAMIC BACKGROUND (NOW FULL PAGE) --- */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        {/* Grid Overlay */}
        <div className="absolute inset-0 opacity-[0.15]"
             style={{ backgroundImage: `radial-gradient(#2B6CB0 1px, transparent 1px)`, backgroundSize: '40px 40px' }} />

        {/* Floating Interactive Shapes */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              animate={{
                x: mousePos.x * (i + 1) * 40,
                y: mousePos.y * (i + 1) * 40,
                rotate: mousePos.x * 45,
              }}
              transition={{ type: 'spring', stiffness: 40, damping: 20 }}
              className="absolute border border-[#2B6CB0]/20 rounded-2xl"
              style={{
                width: `${(i + 1) * 250}px`,
                height: `${(i + 1) * 250}px`,
                left: `${20 + i * 20}%`,
                top: `${15 + i * 20}%`,
              }}
            />
          ))}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .marquee-text { animation: marquee 40s linear infinite; }
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />

      <div className="relative z-10 pt-20 flex items-center justify-center px-8 min-h-screen">
        <div className="text-center relative z-10">
          <span className="text-[#2B6CB0] font-black uppercase tracking-[0.4em] text-xs mb-4 block">
            Insights & Case Studies
          </span>

          <h1 className="text-7xl md:text-9xl font-black text-[#020617] mb-6 tracking-tighter uppercase">
            BLOG<span className="text-[#2B6CB0]">.</span>
          </h1>

          <div className="flex items-center justify-center gap-4 mb-12">
            <div className="h-[1px] w-12 bg-[#4A5568]/20" />
            <p className="text-xl text-[#4A5568] font-medium tracking-wide">
              Coming Soon
            </p>
            <div className="h-[1px] w-12 bg-[#4A5568]/20" />
          </div>

          {/* <button
            onClick={() => onSectionChange('home')}
            className="group flex items-center gap-4 mx-auto bg-[#020617] text-white px-10 py-5 rounded-full font-black uppercase tracking-widest text-[10px] hover:bg-[#2B6CB0] transition-all shadow-xl shadow-[#020617]/10"
          >
            <span className="group-hover:-translate-x-1 transition-transform">←</span>
            Back to Home
          </button> */}
        </div>

        {/* Subtle Footer Tag */}
        <div className="absolute bottom-10 text-[10px] font-bold text-[#4A5568]/40 uppercase tracking-[0.2em]">
          © 2026 Agency Edition
        </div>
      </div>
    </div>
  );
};

export default Blog;